module.exports = "<app-consultation-progress-bar></app-consultation-progress-bar>\r\n<router-outlet></router-outlet>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/consultation-process.component.html
// module id = ../../../../../src/app/pages/consultation-process/consultation-process.component.html
// module chunks = main